module.exports = __webpack_public_path__ + "static/img/1.305e0b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/4/zh/1.png
// module id = yJNu
// module chunks = 0